import type { Components } from '@mui/material/styles';

export default function MuiCardActionArea(): Components['MuiCardActionArea'] {
  return {};
}
